import { useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import CopyToClipboard from 'react-copy-to-clipboard';
import { HiRefresh } from "react-icons/hi";
import { MdOutlineContentCopy } from 'react-icons/md';
import DashboardPage from '../../components/DashboardPage/DashboardPage';
import ErrorLayout from '../../components/Error/ErrorLayout';
import ToasterList, { useToaster } from '../../components/Toaster/ToasterList';
import { apiKeyState, listApiKeys } from '../../features/apiKey/apiKeySlice';
import GenerateKeyModal from '../../features/apiKey/components/GenerateKeyModal';
import ListApiKey from '../../features/apiKey/components/ListApiKey';
import { domainState } from '../../features/domains/domainSlice';
import { useAppDispatch, useAppSelector } from '../../hooks/redux/hooks';

const ApiKeys = () => {
    const dispatch = useAppDispatch();
    const handleRefresh = () => dispatch(listApiKeys());

    const { toastList, addToast } = useToaster();

    const [showToastCopied, setShowCopiedToClipboard] = useState(false);
    const { createdKey, deletedKey, list: apiKeysList } = useAppSelector(apiKeyState);

    const createdKeyRef = useRef("");
    const expirationRef = useRef("");

    useEffect(() => {
        if (deletedKey.isSuccess) {
            addToast({ idx: 'keyDeleted', theme: 'success', title: 'Success', body: () => <>Successfully deleted the API key</> });
        }
        if (createdKey.isSuccess && createdKey.apiKey) {
            createdKeyRef.current = createdKey.apiKey as string;
            expirationRef.current = createdKey.expiration as string;
            addToast({
                idx: 'keyCreated', theme: 'light', title: 'Success', autohide: false, body: () => (<>
                    <p>Keep your key <strong>safe</strong></p>
                    <p>Save and store this new key to a secure place, such as a <strong>password manager or secret store</strong>.</p>
                    <p>You won’t be able to see it again.</p>
                    {/* <p>This key will expire <strong>{moment(expirationRef.current).format('MMMM Do YYYY, h:mm:ss a')}</strong></p> */}
                    <p><code>{createdKeyRef.current}</code></p>
                    <Container className="ms-auto d-flex justify-content-center">
                        <CopyToClipboard
                            text={createdKeyRef.current}
                            onCopy={() => setShowCopiedToClipboard(true)}>
                            <Button variant='primary'>Copy to clipboard <MdOutlineContentCopy /></Button>
                        </CopyToClipboard>
                    </Container>

                </>)
            });
        }
        if (showToastCopied) {
            addToast({ idx: 'keyCopied', theme: 'success', title: 'Success', body: () => (<>Woohoo, API key copied in clipboard !</>), onCloseEvent: () => setShowCopiedToClipboard(false) });
        }
    }, [createdKey, deletedKey, showToastCopied, setShowCopiedToClipboard]);


    const { list: domainsList } = useAppSelector(domainState);

    useEffect(() => {
        if (createdKey.error) {
            const error = createdKey.error;
            addToast({ idx: 'keyError', theme: 'danger', title: 'Error', body: () => <ErrorLayout error={error} /> });
        } else if (deletedKey.error) {
            const error = deletedKey.error;
            addToast({ idx: 'keyError', theme: 'danger', title: 'Error', body: () => <ErrorLayout error={error} /> });
        } else if (apiKeysList.error) {
            const error = apiKeysList.error;
            addToast({ idx: 'keyError', theme: 'danger', title: 'Error', body: () => <ErrorLayout error={error} /> });
        } else if (domainsList.error) {
            const error = domainsList.error;
            addToast({ idx: 'keyError', theme: 'danger', title: 'Error', body: () => <ErrorLayout error={error} /> });
        }
    }, [createdKey, deletedKey, apiKeysList, domainsList]);

    return (
        <>
            <DashboardPage heading="API keys">
                <Card>
                    <Card.Header>
                        <Row>
                            <Col md={8} sm={7} xs={7}>
                                <Card.Title className="mb-2">API keys</Card.Title>
                                <Card.Subtitle className="text-muted">These keys will allow you to authenticate API requests.</Card.Subtitle>
                            </Col>
                            <Col className="hstack gap-3 d-flex justify-content-end align-items-center">
                                <Button variant="light" onClick={handleRefresh}><HiRefresh /> </Button>
                                <GenerateKeyModal />
                            </Col>
                        </Row>
                    </Card.Header>
                    <Card.Body >
                        <ListApiKey />
                    </Card.Body>
                </Card>
            </DashboardPage>
            <ToasterList list={toastList} />
        </>
    )
}

export default ApiKeys;